import { line, ScaleLinear, ScaleTime } from "d3";

export const D3Helper = {
  createYAxisLabel: () => { },
  createXAxisLabel: () => { },
  lineFunc: (x: ScaleTime<any, any>, y: ScaleLinear<any, any>, key: string) => {
    return line<any>()
      .x((d) => x(d.date))
      .y((d) => y(d[key]));
  },

  formatCompactNumber: (value: number): string => {
    if (value === 0) return '0';

    const absValue = Math.abs(value);
    const sign = value < 0 ? '-' : '';

    if (absValue >= 1000000) {
      return sign + (absValue / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (absValue >= 1000) {
      return sign + (absValue / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    } else {
      return value.toString();
    }
  },

  barFunc: () => { },
}
// export let D3Helper;
// export const D3Helper = Object.setPrototypeOf({}, {
//   createYAxisLabel: () => { },
//   createXAxisLabel: () => { },
//   xScaleFunc: () => { },
//   lineFunc: (x: ScaleTime<any, any>, y: ScaleLinear<any, any>, key: string) => {
//     return line<any>().x((d) => x(d.date)).y((d) => y(d[key]));
//   },

//   barFunc: () => { },
// });
